import React from 'react'
import { IssueEntity } from '../../../types/IssueEntity'
import { CommitChart } from './CommitChart'
import { valueFormatter } from './utils'
import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'

export const CommitChartWithNoInvestorsApproxCommitment = ({
    approxTotalCommitment,
}: {
    approxTotalCommitment: IssueEntity['approxTotalCommitment']
}) => {
    const theme = useTheme()
    const { i18n } = useTranslation()
    const locale = i18n.language

    if (!approxTotalCommitment) return null

    const totalCommitment = parseFloat(approxTotalCommitment)

    const series = [
        {
            stack: 'A',
            label: 'Totalt åtagande',
            data: [totalCommitment],
            valueFormatter: valueFormatter(locale),
            color: theme.palette.info.main,
        },
    ]

    if (totalCommitment < 100) {
        series.push({
            stack: 'A',
            label: 'Ej säkerställt',
            data: [100 - totalCommitment],
            valueFormatter: valueFormatter(locale),
            color: theme.palette.grey[200],
        })
    }

    return <CommitChart series={series} locale={locale} />
}
